import { useAction, useAtom } from '@reatom/npm-react'
import { css } from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { ConfirmDialog, LogoutExactIcon } from '@root/shared/ui-kit'

import { logoutAction, logoutDialogAtom } from '../atoms'

export const LogoutDialog = () => {
  const { t } = useTranslation()
  const logout = useAction(logoutAction)
  const [isOpen, setIsOpen] = useAtom(logoutDialogAtom)

  return (
    <ConfirmDialog
      variant="bordered"
      icon={<LogoutExactIcon size={14} />}
      describedBy={t('auth.log-out')}
      header={t('auth.log-out')}
      title={t('auth.logout-message')}
      intent="error"
      open={isOpen}
      onOpenChange={setIsOpen}
      onCancel={() => setIsOpen(false)}
      confirmLabel={t('auth.log-out')}
      onConfirm={logout}
      css={css`
        div > div:nth-child(2) {
          width: 200px;
          margin-bottom: 0;
        }
        div > div:nth-child(3) {
          margin-top: 15px;
        }
      `}
    />
  )
}
